import React, { useState } from "react";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import "../../../../Utils/Css/Menu.css";

export default function Menu({
  pending_search,
  handlewSort,
  pending_delete,
  userType,
}) {
  const [sortConfig, setSortConfig] = useState({ key: null, direction: null });

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const newSort = { key, direction };
    setSortConfig(newSort);

    if (pending_search && Array.isArray(pending_search)) {
      const sortedData = [...pending_search].sort((a, b) => {
        let aVal = a[key];
        let bVal = b[key];

        // ✅ Handle null/undefined
        if (aVal == null) aVal = "";
        if (bVal == null) bVal = "";

        // ✅ Special case: profit_loss numeric sort
        if (key === "profit_loss") {
          const numA = parseFloat(aVal) || 0;
          const numB = parseFloat(bVal) || 0;
          return direction === "asc" ? numB - numA : numA - numB;
        }

        // ✅ Date sorting
        if (key.toLowerCase().includes("date")) {
          const dateA = new Date(aVal).getTime();
          const dateB = new Date(bVal).getTime();
          return direction === "asc" ? dateA - dateB : dateB - dateA;
        }

        // ✅ General number sorting
        if (!isNaN(parseFloat(aVal)) && !isNaN(parseFloat(bVal))) {
          const numA = parseFloat(aVal);
          const numB = parseFloat(bVal);
          return direction === "asc" ? numA - numB : numB - numA;
        }

        // ✅ Fallback string sorting
        return direction === "asc"
          ? String(aVal).localeCompare(String(bVal))
          : String(bVal).localeCompare(String(aVal));
      });

      if (handlewSort) {
        handlewSort(sortedData);
      }
    }
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="sortIcon" />;
    return sortConfig.direction === "asc" ? (
      <FaSortUp className="sortIcon" />
    ) : (
      <FaSortDown className="sortIcon" />
    );
  };

  return (
    <div className="menuContainer primary white">
      <div className="menuExchange small" onClick={() => handleSort("script_type")}>
        EXCH {renderSortIcon("script_type")}
      </div>
      {userType === 1 ? (
        <div
          className="menuExchange small"
          onClick={() => handleSort("super_username")}
        >
          SUPER {renderSortIcon("super_username")}
        </div>
      ) : null}
      {userType === 1 || userType === 2 ? (
        <div
          className="menuExchange small"
          onClick={() => handleSort("master_username")}
        >
          MASTER {renderSortIcon("master_username")}
        </div>
      ) : null}
      {userType === 1 || userType === 2 || userType === 3 || userType === 5 ? (
        <div className="menuExchange small" onClick={() => handleSort("username")}>
          USER {renderSortIcon("username")}
        </div>
      ) : null}

      <div className="menuSymbol small" onClick={() => handleSort("symbol")}>
        SYMBOL {renderSortIcon("symbol")}
      </div>
      <div className="menuExpiry small" onClick={() => handleSort("expiry_date")}>
        EXPIRY {renderSortIcon("expiry_date")}
      </div>
      <div className="menuSellQty small" onClick={() => handleSort("buy_sell")}>
        B/S {renderSortIcon("buy_sell")}
      </div>
      <div className="menuBuyPrice small" onClick={() => handleSort("qty")}>
        NET QTY {renderSortIcon("qty")}
      </div>
      <div className="menuBuyPrice small" onClick={() => handleSort("rate")}>
        RATE {renderSortIcon("rate")}
      </div>
      <div className="menuSellQty small" onClick={() => handleSort("high_mid")}>
        LIMIT-TYPE {renderSortIcon("high_mid")}
      </div>
      <div className="menuSellQty small" onClick={() => handleSort("type")}>
        TYPE {renderSortIcon("type")}
      </div>
      <div className="menuSymbol small" onClick={() => handleSort("msg")}>
        MSG {renderSortIcon("msg")}
      </div>
      <div className="menuLtt small white" onClick={() => handleSort("date_cancel")}>
        C-DATE {renderSortIcon("date_cancel")}
      </div>
      <div className="menuLtt small" onClick={() => handleSort("date_created")}>
        DATE {renderSortIcon("date_created")}
      </div>
      {userType === 4 && (
        <div className="menuBuyQty small" onClick={() => handleSort("status")}>
          ACTION {renderSortIcon("status")}
        </div>
      )}
      <div className="menuBuyQty small" onClick={() => handleSort("status")}>
        STATUS {renderSortIcon("status")}
      </div>
      {pending_delete && userType === 1 ? (
        <div className="menuBuyQty">ACTION</div>
      ) : null}
    </div>
  );
}
